import { gql, useQuery } from '@apollo/client';

/**
 * 区域包裹信息类型
 */
export interface AreaParcelInfoType {
  /** 包裹号 */
  trackingNumber: string;
  /** 区域名称 */
  areaName: string | null;
  /** 站点号 */
  stopNumber: number;
  /** 子站点号 */
  subStopNumber: string;
  /** 是否已取件 */
  isPickedUp: boolean;
  /** 最后扫描人姓名 */
  lastScannerName: string | null;
  /** 分配的司机姓名 */
  allocationDriverName: string | null;
}

/**
 * 区域扫描统计响应
 */
export interface AreaScanStatisticsResponse {
  /** 包裹列表 */
  parcelList: AreaParcelInfoType[];
}

/**
 * GraphQL查询响应类型
 */
export interface GetAreaScanStatisticsQuery {
  getAreaScanStatistics: AreaScanStatisticsResponse;
}

/**
 * 获取当前登录人同区域的所有CREATE或PICKUP状态的派送任务统计
 */
export const GET_AREA_SCAN_STATISTICS = gql`
  query GetAreaScanStatistics {
    getAreaScanStatistics {
      parcelList {
        trackingNumber
        areaName
        stopNumber
        subStopNumber
        isPickedUp
        lastScannerName
        allocationDriverName
      }
    }
  }
`;

export const useGetAreaScanStatistics = () => {
  return useQuery<GetAreaScanStatisticsQuery>(GET_AREA_SCAN_STATISTICS, {
    fetchPolicy: 'network-only', // 每次都从服务器获取最新数据
    notifyOnNetworkStatusChange: true, // 网络状态变化时通知
  });
};

